import {App} from './App'
import {Index} from './routes/Index'
import {ShowApp} from './routes/ShowApp'
import {ShowAction} from './routes/ShowAction'
import {IndexModels} from './routes/models/IndexModels'
import {Playground} from './routes/models/Playground'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {ShowModel} from './routes/models/show/ShowModel'

registerReactAppFactory('marketplace-react', () => ({
  App,
  routes: [
    jsonRoute({path: '/marketplace', Component: Index}),
    jsonRoute({path: '/marketplace/:slug', Component: ShowApp}),
    jsonRoute({path: '/marketplace/actions/:slug', Component: ShowAction}),
    jsonRoute({path: '/marketplace/models', Component: IndexModels}),
    jsonRoute({path: '/marketplace/models/:registry/:model', Component: ShowModel}),
    jsonRoute({path: '/marketplace/models/:registry/:model/playground', Component: Playground}),
    jsonRoute({path: '/marketplace/models/:registry/:model/playground/code', Component: Playground}),
  ],
}))
